export enum NotificationStatus {
  signing = 'signing',
  success = 'success',
  error = 'error',
  pending = 'pending'
}
